import { ArrowLeftRight } from "lucide-react";
import { siteConfig, waHref } from "@/config/siteConfig";
import { trackEvent } from "@/lib/analytics";
import { SectionHeading } from "@/components/SectionHeading";
import { Reveal } from "@/components/Reveal";
import { WhatsAppIcon } from "@/components/WhatsAppIcon";

export const Intercity = () => (
  <section id="sehirler-arasi" data-testid="intercity-section" className="scroll-mt-20 bg-ink-900 py-20 md:py-28">
    <div className="mx-auto max-w-6xl px-5">
      <SectionHeading
        eyebrow="Şehirler Arası"
        title="Şehirler Arası Araç Taşıma"
        desc="Salihli merkezli olarak şehirler arası araç taşıma hizmeti sunuyor, Türkiye genelinde araçlarınızı güvenli şekilde taşıyoruz."
        dark
        testid="intercity-heading"
      />
      <div className="mt-12 grid gap-5 md:grid-cols-2">
        {siteConfig.routes.map((route, i) => (
          <Reveal key={`${route.from}-${route.to}`} delay={i * 0.08}>
            <div
              data-testid={`route-card-${i}`}
              className="group flex h-full flex-col justify-between rounded-3xl border border-white/10 bg-ink-800 p-8 transition-[border-color,transform] duration-300 hover:-translate-y-1 hover:border-brand/40 md:p-10"
            >
              <p className="flex flex-wrap items-center gap-x-4 gap-y-2 font-display text-3xl font-black uppercase tracking-tight text-white sm:text-4xl">
                {route.from}
                <span className="grid h-11 w-11 place-items-center rounded-full bg-brand" aria-hidden="true">
                  <ArrowLeftRight className="h-5 w-5 text-white" />
                </span>
                {route.to}
              </p>
              <p className="mt-4 font-display text-sm font-bold uppercase tracking-[0.2em] text-white/50">
                {route.note}
              </p>
            </div>
          </Reveal>
        ))}
      </div>
      <Reveal delay={0.15}>
        <div className="mt-6 flex flex-col items-start justify-between gap-6 rounded-3xl bg-brand p-8 shadow-2xl shadow-brand/25 md:flex-row md:items-center md:p-10">
          <div>
            <p className="font-display text-2xl font-black uppercase tracking-tight text-white sm:text-3xl" data-testid="turkiye-geneli-title">
              Türkiye Geneli Araç Taşıma
            </p>
            <p className="mt-2 max-w-md text-sm font-semibold leading-relaxed text-white/85">
              Nereden nereye olursa olsun; aracınızın bilgilerini gönderin, fiyatı ve tahmini süreyi önceden öğrenin.
            </p>
          </div>
          <a
            href={waHref(siteConfig.whatsapp.intercityMessage)}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="intercity-quote-button"
            onClick={() => trackEvent("whatsapp_click", "intercity")}
            className="inline-flex min-h-[52px] shrink-0 items-center gap-3 rounded-full bg-white px-8 py-4 font-display text-base font-extrabold uppercase tracking-wide text-ink-900 shadow-xl transition-[transform,box-shadow] duration-200 hover:scale-105 active:scale-95"
          >
            <WhatsAppIcon className="h-5 w-5 text-wa-dark" />
            Araç Taşıma Fiyatı Al
          </a>
        </div>
      </Reveal>
    </div>
  </section>
);
